import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class GlobalService {
  constructor(private snakbar: MatSnackBar) {}

  openSnackBar(message: string, type: 'success' | 'error' | 'caution') {
    const styleClass = `${type}-metadados`;

    this.snakbar.open(message, 'Fechar', {
      duration: 6000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: styleClass
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/global/global.service.ts